import React from "react";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Field from "../shared/Field";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormTeam = ({ draft, setDraft }) => {
  const colorOptions = [
    "bg-orange-50 text-orange-600",
    "bg-[#eaf4f1] text-[#0b6e5f]",
    "bg-orange-100 text-orange-700",
  ];

  const updateSkill = (si, field, value) => {
    const skills = [...(draft.skills || [])];
    skills[si] = { ...skills[si], [field]: value };
    setDraft((p) => ({ ...p, skills }));
  };

  const addSkill = () =>
    setDraft((p) => ({
      ...p,
      skills: [...(p.skills || []), { name: "", color: colorOptions[0] }],
    }));

  const removeSkill = (si) =>
    setDraft((p) => ({
      ...p,
      skills: p.skills.filter((_, idx) => idx !== si),
    }));

  return (
    <Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <Field
          label="Full Name"
          value={draft.name}
          onChange={(v) => setDraft((p) => ({ ...p, name: v }))}
          placeholder="Suzan Amadi"
        />
        <Field
          label="Role / Title"
          value={draft.role}
          onChange={(v) => setDraft((p) => ({ ...p, role: v }))}
          placeholder="Lead Developer"
        />
      </Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <ImageUploadField
          label="Photo"
          value={draft.photoUrl}
          onChange={(v) => setDraft((p) => ({ ...p, photoUrl: v }))}
        />
        <Field
          label="Experience"
          value={draft.experience}
          onChange={(v) => setDraft((p) => ({ ...p, experience: v }))}
          placeholder="2+ Years"
        />
      </Box>

       <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <FormControl size="small" fullWidth>
          <InputLabel>Show as Founder?</InputLabel>
          <Select
            value={draft.isFounder || false}
            label="Show as Founder?"
            onChange={(e) =>
              setDraft((p) => ({ ...p, isFounder: e.target.value }))
            }
            sx={{ borderRadius: "8px" }}
          >
            <MenuItem value={false}>No — Regular member</MenuItem>
            <MenuItem value={true}>Yes — Highlighted founder card</MenuItem>
          </Select>
        </FormControl>
        <Field
          label="Badge Text (optional)"
          value={draft.badge}
          onChange={(v) => setDraft((p) => ({ ...p, badge: v }))}
          placeholder="Founder"
        />
      </Box>

      {draft.isFounder && (
        <>
          <TextField
            fullWidth
            multiline
            rows={3}
            size="small"
            label="Bio (shown only on founder card)"
            value={draft.bio || ""}
            onChange={(e) =>
              setDraft((p) => ({ ...p, bio: e.target.value }))
            }
            placeholder="8+ years building scalable WordPress websites..."
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <Box display="grid" gridTemplateColumns="1fr 1fr 1fr" gap={2} mb={2}>
            <Field
              label="LinkedIn URL"
              value={draft.linkedinUrl}
              onChange={(v) => setDraft((p) => ({ ...p, linkedinUrl: v }))}
              placeholder="https://linkedin.com/in/..."
            />
            <Field
              label="Email"
              value={draft.email}
              onChange={(v) => setDraft((p) => ({ ...p, email: v }))}
              placeholder="founder@company.com"
            />
            <Field
              label="Website URL"
              value={draft.websiteUrl}
              onChange={(v) => setDraft((p) => ({ ...p, websiteUrl: v }))}
              placeholder="https://..."
            />
          </Box>
        </>
      )}




      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        display="block"
        mb={1}
        mt={1}
      >
        Skills
      </Typography>
      {(draft.skills || []).map((skill, si) => (
        <Box key={si} display="flex" gap={1} mb={1} alignItems="center">
          <TextField
            size="small"
            label="Skill Name"
            value={skill.name}
            onChange={(e) => updateSkill(si, "name", e.target.value)}
            placeholder="React"
            sx={{
              flex: 2,
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
          <FormControl size="small" sx={{ flex: 2 }}>
            <InputLabel>Color</InputLabel>
            <Select
              value={skill.color}
              label="Color"
              onChange={(e) => updateSkill(si, "color", e.target.value)}
              sx={{ borderRadius: "8px" }}
            >
              {colorOptions.map((c) => (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <IconButton
            size="small"
            color="error"
            onClick={() => removeSkill(si)}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={addSkill}
        sx={{ textTransform: "none", color: "text.secondary", mt: 0.5 }}
      >
        Add Skill
      </Button>
    </Box>
  );
};

export default FormTeam;
